"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),require("./es6Promise"),require("./objectAssign"),require("./objectKeys");


//////////////////
// WEBPACK FOOTER
// ./node_modules/dingtalk-jsapi/lib/polyfills/index.js
// module id = abBl
// module chunks = 12